import React from 'react'

import { Card } from '@material-ui/core'

import HeaderWithFilterButton from '../CommonContent/IndividualHeader/IndividualHeader'
import HeaderWithActions from '../CommonContent/IndividualActionGroups/IndividualActionGroups'
import CardList from './CardContainer/CardContainer'
import Spinner from '../../../UI/Spinner/Spinner'

const corporateContent = ({
  companyName,
  copyButtonClicked,
  orgRecords,
  pagination,
  pageChanged,
  perPageChanged,
  assignButtonClicked,
  assignButtonDisabled,
  filterButtonClicked,
  exportButtonClicked,
  exportButtonDisabled,
  importButtonClicked,
  selectedOrgs,
  selectedResults,
  selectAllClicked,
  selectAllDisabled,
  orgCheckboxChanged,
  deleteButtonClicked,
  filtered,
  pageLoading,
  pagePermission,
  bulkDeleteButtonClicked,
  bulkDeleteButtonDisabled,
  actionClicked,
  actionDisabled
}) => {
  let content = <Spinner />
  if (!pageLoading) {
    content = (
      <CardList
        copyButtonClicked={copyButtonClicked}
        deleteButtonClicked={deleteButtonClicked}
        orgRecords={orgRecords}
        pagination={pagination}
        pageChanged={pageChanged}
        perPageChanged={perPageChanged}
        selectedOrgs={selectedOrgs}
        selectedResults={selectedResults}
        orgCheckboxChanged={orgCheckboxChanged}
        filtered={filtered}
        pagePermission={pagePermission}
      />
    )
  }

  return (
    <Card>
      <HeaderWithFilterButton
        pagePermission={pagePermission}
        filterButtonClicked={filterButtonClicked}
        exportButtonClicked={exportButtonClicked}
        importButtonClicked={importButtonClicked}
        exportButtonDisabled={exportButtonDisabled}
        pageTranslateKey={'corporateAssignment'}
      />
      <HeaderWithActions
        companyName={companyName}
        selectAllClicked={selectAllClicked}
        selectAllDisabled={selectAllDisabled}
        assignButtonClicked={assignButtonClicked}
        assignDisabled={assignButtonDisabled || selectedOrgs.length === 0 || !pagePermission.is_add}
        bulkDeleteButtonClicked={bulkDeleteButtonClicked}
        bulkDeleteDisabled={bulkDeleteButtonDisabled || !pagePermission.is_delete}
        actionClicked={actionClicked}
        actionDisabled={actionDisabled}
      />
      {content}
    </Card>
  )
}

export default corporateContent
